import { createDispatcher, usePlayerContext } from '@vime/core';
const findPlayer = (component) => {
    var _a;
    if (!component)
        return null;
    const players = Array.from(document.querySelectorAll('vime-player'));
    return (_a = players.find((player) => player.contains(component.$el))) !== null && _a !== void 0 ? _a : null;
};
export const VimeMixin = (props) => ({
    data() {
        return Object.assign({ player: null, playerDispatch: () => { }, unbindPlayerContext: () => { } }, (props.reduce((prev, prop) => (Object.assign(Object.assign({}, prev), { [prop]: undefined })), {})));
    },
    watch: props.reduce((prev, prop) => (Object.assign(Object.assign({}, prev), { [prop](value) {
            this.playerDispatch(prop, value);
        } })), {}),
    mounted() {
        this.player = findPlayer(this);
        if (this.player === null)
            return;
        this.playerDispatch = createDispatcher(this.$el);
        this.unbindPlayerContext = usePlayerContext(this.$el, props, ((prop, value) => { this[prop] = value; }), this.player);
    },
    beforeDestroy() {
        this.unbindPlayerContext();
    },
});
//# sourceMappingURL=mixins.js.map